"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merge = merge;
var _events = require("../../types/events");
var _social = require("../../types/social");
var _action_types = require("../../constants/action_types");
var _authenticate = require("./authenticate");
var _tracking = require("../../utils/tracking");
var _mergeUser = require("../../repositories/social-users/v1/merge-user");
function merge(parameters) {
  const {
    socialType,
    socialLoginId,
    email,
    password,
    source
  } = parameters;
  return (dispatch, _getState, context) => {
    const {
      httpApi
    } = context;
    dispatch({
      type: _action_types.SOCIAL_MERGE_TYPE,
      status: _social.EMergeStatus.Loading
    });
    return (0, _mergeUser.fetchMergeUser)({
      httpApi,
      parameters: {
        socialLoginId,
        email,
        password
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
          withCredentials: true
        }
      }
    }).then(response => {
      if (response.statusCode === 200) {
        const socialLoginId = response.response.socialLoginId;
        const email = response.response.email || '';
        const token = response.response.token || '';
        dispatch({
          type: _action_types.SOCIAL_MERGE_TYPE,
          status: _social.EMergeStatus.Succeed
        });
        context.emitter.emit(_events.EEventType.SocialMergeSucceed);
        (0, _tracking.trackSocialMergeSucceed)(source);
        dispatch((0, _authenticate.authenticate)({
          socialType,
          socialLoginId,
          email,
          token,
          source
        }));
        return;
      }
      dispatch({
        type: _action_types.SOCIAL_MERGE_TYPE,
        status: _social.EMergeStatus.Failed,
        error: response.response.message
      });
    }).catch(error => {
      context.logger.error(error, {
        domain: 'auth-widget.api.socialMerge',
        socialType
      });
      dispatch({
        status: _social.EMergeStatus.Failed,
        type: _action_types.SOCIAL_MERGE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}